import isEmpty from "lodash/isEmpty";
import { FillRoleModal } from "PFApp/audit_planner/parts/modals/fill_role_modal";
import { RequestApprovalModal } from "PFApp/audit_planner/parts/modals/request_approval_modal";
import { Button } from "PFComponents/button";
import { useActivityInvalidate } from "PFCore/hooks/queries/activity";
import { useAuditRolesInvalidate } from "PFCore/hooks/queries/audit_planner/audit_roles/use_audit_roles_invalidate";
import { useShortlistsInvalidate } from "PFCore/hooks/queries/shortlists/use_shortlists_invalidate";
import { fetchPotentialExceptions } from "PFCore/services/audit_planner";
import {
  _AuditPlannerExceptionsDictionary,
  Activity,
  AuditPlannerExceptionsDictionary,
  AuditRole,
  Engagement,
  Shortlist
} from "PFTypes";
import { useState } from "react";
import { useTranslation } from "react-i18next";

type FillAuditRoleButtonProps = {
  shortlistItem: Shortlist;
  activity: Activity;
  engagement: Activity;
};

export const FillAuditRoleButton = ({ shortlistItem, activity, engagement }: FillAuditRoleButtonProps) => {
  const { invalidateShortlists } = useShortlistsInvalidate();
  const { invalidateAll: invalidateAuditRoles } = useAuditRolesInvalidate();

  const [exceptionsChecked, setExceptionsChecked] = useState<AuditPlannerExceptionsDictionary | null>(null);
  const [showModal, setShowModal] = useState(false);
  const canFill =
    !["exception", "booked", "filled", "confirmed"].includes(activity.workflow_state) &&
    activity.state !== "complete";

  const { t } = useTranslation("activities");
  const { invalidate: invalidateActivities } = useActivityInvalidate();

  const onClick = (event: React.MouseEvent) => {
    event.stopPropagation();
    fetchPotentialExceptions({
      activityId: activity.id,
      profileId: shortlistItem.profile.id
    }).then((exceptions) => {
      if (exceptions) {
        setExceptionsChecked(exceptions);
      }
      setShowModal(true);
    });
  };

  const handleSuccess = () => {
    invalidateActivities([activity.id]);
    invalidateShortlists(activity.id);
    invalidateAuditRoles();
  };

  return (
    <>
      <Button
        text={t("show.parts.fillRole")}
        kind="secondary"
        disabled={!canFill}
        onClick={onClick}
        style={{ marginLeft: "auto" }}
      />
      {showModal &&
        (!isEmpty(exceptionsChecked) ? (
          <RequestApprovalModal
            shortlistItem={shortlistItem}
            exception={exceptionsChecked as unknown as _AuditPlannerExceptionsDictionary}
            role={activity}
            engagement={engagement as unknown as Engagement}
            onClose={() => setShowModal(false)}
            onSuccess={handleSuccess}
          />
        ) : (
          <FillRoleModal
            shortlistItem={shortlistItem}
            role={activity as unknown as AuditRole}
            engagement={engagement as unknown as Engagement}
            onClose={() => setShowModal(false)}
            onSuccess={handleSuccess}
          />
        ))}
    </>
  );
};
